<template>
  <div class="upload-less">
    <el-upload
      drag
      :action="uploadUrl"
      :data="{path:path}"
      :on-success="onSuccess"
      :on-error="onError"
      :on-remove="onRemove"
      :with-credentials="true"
      :file-list="value.map(x=>Object({name:x}))"
      multiple
    >
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
    </el-upload>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    path: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      uploadUrl: process.env.VUE_APP_DATA_URL + '/file/upload'
    }
  },
  methods: {
    onSuccess (response, file, fileList) {
      if (fileList.length !== 0) {
        const files = fileList
          .filter(x => x.status === 'success')
          .map(x => x.name)
        this.$emit('input', files)
      }
    },
    onRemove (file, fileList) {
      const files = fileList
        .filter(x => x.status === 'success')
        .map(x => x.name)
      this.$emit('input', files)
    },
    onError (err, file, fileList) {
      this.$message.error(`文件上传失败: ${err}`)
    }
  }
}
</script>

<style scope>
.upload-less {
  width: 100%;
}
.upload-less .el-upload {
  display: inherit;
}
.upload-less .el-upload-dragger {
  height: 50px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/common/Upload.vue